<template>
	<b-modal
		v-model="isModalActive"
		:width="800"
		scroll="clip">
		<b-carousel
			:indicator-inside="false"
			:pause-info="false"
			icon-pack="fas"
			v-model="index">
			<b-carousel-item
				v-for="(image, i) in images"
				:key="i"
				class="has-text-centered">
				<img
					:src="image"
					style="height: 500px; max-width: 600; object-fit: contain" />
			</b-carousel-item>
			<template #indicators="props">
				<img
					style="height: 100px; width: 100px; object-fit: cover"
					:src="images[props.i]" />
			</template>
		</b-carousel>
	</b-modal>
</template>

<script>
	export default {
		props: {
			images_prop: Array,
		},
		data() {
			return {
				isModalActive: false,
				index: 0,
			};
		},
		computed: {
			images() {
				return this.$props.images_prop;
			},
		},
		methods: {
			toggle() {
				this.isModalActive = !this.isModalActive;
			},
			activate(value) {
				this.index = value;
				this.isModalActive = true;
			},
		},
	};
</script>

<style>
	.is-active .al img {
		filter: grayscale(0%);
	}
	.al img {
		filter: grayscale(100%);
	}
</style>
